module.exports = __webpack_public_path__ + "media/images/athletes/2835-444fda516ec5c7374c8dc1928d76b56d.png";